module.exports = __webpack_public_path__ + "img/el-icon-purchase.svg";